import { API_URL, API_USER_URL } from "@/env";
import { message } from "antd";
import { PackageSummaryAPI, RegistrationPackageAPI, UserInPackageAPI } from "./type";

const API_USE = API_URL || '';


export interface RegistrationPackageInput {
    user_id: string;
    package_id: string;
    started_at: string;
}

async function crateUserPackage(input: RegistrationPackageInput): Promise<RegistrationPackageAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }
    
    try {
        const dataInput = {
            user_id: input.user_id,
            package_id: input.package_id,
            started_at: input.started_at
        }
        const response = await fetch(`${API_USE}/api/v1/be/tools/package`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(dataInput)
        });
        if (!response.ok) {
            message.error('Error registering package');
            throw new Error(`Error registering package: ${response.statusText}`);
        }
        const data = await response.json();
        return data as RegistrationPackageAPI;
    } catch (error) {
        console.error('Failed to register package:', error);
        throw error;
    }
}

interface CreateTransactionForPackageInput {
    amount: number;
    user_package_id: string;
    transaction_type: string;
    created_at: string;
}
async function createTransactionForPackage(input: CreateTransactionForPackageInput): Promise<void> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const dataInput = {
            amount: input.amount,
            user_package_id: input.user_package_id,
            transaction_type: input.transaction_type,
            created_at: input.created_at
        }
        const response = await fetch(`${API_USE}/api/v1/be/tools/transaction`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(dataInput)
        });
        if (!response.ok) {
            message.error('Error creating transaction for package');
            throw new Error(`Error creating transaction for package: ${response.statusText}`);
        }
    } catch (error) {
        console.error('Failed to create transaction for package:', error);
        throw error;
    }
}

interface CaculateUserPackageInput {
    user_name: string;
    user_package_id: string;
}

async function caculateUserPackage(input: CaculateUserPackageInput): Promise<void> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const dataInput = {
            user_name: input.user_name,
            user_package_id: input.user_package_id
        }
        const response = await fetch(`${API_USE}/api/v1/be/tools/calculate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(dataInput)
        });
        if (!response.ok) {
            message.error('Error calculating user package');
            throw new Error(`Error calculating user package: ${response.statusText}`);
        }
    } catch (error) {
        console.error('Failed to calculate user package:', error);
        throw error;
    }
}

async function splittingPackage(id: string, split_to: number, name: string): Promise<void> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const dataInput = {
            split_factor: split_to,
            name: name
        }
        const response = await fetch(`${API_USE}/api/v1/be/admin/packages/split/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(dataInput)
        });
        if (!response.ok) {
            message.error('Error splitting package');
            throw new Error(`Error splitting package: ${response.statusText}`);
        }
    } catch (error) {
        console.error('Failed to split package:', error);
        throw error;
    }
}

async function addUserToPackage(user_ids: number[], package_id: string): Promise<UserInPackageAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const dataInput = {
            user_ids: user_ids,
            package_id: package_id
        }
        const response = await fetch(`${API_USE}/api/v1/be/admin/user-packages/assign`, {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(dataInput)
        });
        if (!response.ok) {
            message.error('Error adding users to package');
            throw new Error(`Error adding users to package: ${response.statusText}`);
        }
        const result: UserInPackageAPI = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to add users to package:', error);
        throw error;
    }
}

async function fetchAllPackageSummary(): Promise<PackageSummaryAPI> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/packages/summary`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to fetch package summaries');
        }
        const result: PackageSummaryAPI = await response.json();
        return result;
    } catch (error) {
        message.error('Lỗi khi lấy tổng quan các gói');
        console.error('Failed to fetch package summaries:', error);
        throw error;
    }
}

async function changeReferralUserOfPackage(user_package_id: number, new_referral_code: string, tranfer_date: string): Promise<void> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }
    try {
        const response = await fetch(`${API_USE}/api/v1/be/admin/commissions/transfer`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                user_package_id,
                new_referral_code,
                from_date: tranfer_date
            })
        });
        if (!response.ok) {
            message.error('Error changing referral user of package');
            throw new Error(`Error changing referral user of package: ${response.statusText}`);
        }
    } catch (error) {
        console.error('Failed to change referral user of package:', error);
        throw error;
    }
}

export {
    crateUserPackage,
    createTransactionForPackage,
    caculateUserPackage,
    splittingPackage,
    addUserToPackage,
    fetchAllPackageSummary,
    changeReferralUserOfPackage
}